import { useCallback } from 'react';
import type { ReviewFormData } from '../components/common/interfaces';

interface UseReviewSubmissionOptions {
  formData: ReviewFormData;
  onSubmit: (formData: ReviewFormData) => Promise<void>;
  onSubmissionComplete: () => void;
}

interface UseReviewSubmissionReturn {
  handleSubmit: () => Promise<void>;
}

export const useReviewSubmission = ({
  formData,
  onSubmit,
  onSubmissionComplete,
}: UseReviewSubmissionOptions): UseReviewSubmissionReturn => {
  const handleSubmit = useCallback(async () => {
    try {
      await onSubmit(formData);
      onSubmissionComplete();
    } catch (error) {
      console.error('Form submission failed:', error);
    }
  }, [onSubmit, formData, onSubmissionComplete]);

  return {
    handleSubmit,
  };
};
